// @ts-ignore
import { SwiperOptions } from 'swiper';
import {Pagination, Navigation } from 'swiper/modules';

export const GallerySliderConfig: SwiperOptions = {

    // grabCursor: true,
    // centeredSlides: true,
    slidesPerView: 2,
    loop: true,
    spaceBetween: 5,
    modules: [Navigation],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    keyboard:{
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true
    },
    breakpoints: {

        320: {
            slidesPerView: 1
        },
        640: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 3
        },
        992: {
            slidesPerView: 3,
            slideShadows: 3
        }
    }
};